// @flow

import Resource from 'speed-js-core/src/api/Resource';
import type { UUID } from 'esm-web-pro/types/common';

export default class GISPointResource extends Resource {
    basePath: string = 'networks/gis-points/';

    objectPath: string = 'networks/gis-points/{ident}/';

    connectedLines(id: UUID) {
        return this.client._request(`${this._getObjectPath(id)}connected_lines/`, 'GET')
            .then((response) => response.data);
    }
}
